<template>
  <v-container fluid>
    <v-data-iterator v-if="student_exams.length"
        :items="student_exams"
        hide-default-footer
    >
      <template v-slot:header>
        <v-toolbar
            class="mb-2"
            color="indigo darken-5"
            dark
            flat
        >
          <v-toolbar-title>Расписание студента</v-toolbar-title>
        </v-toolbar>
      </template>
      <template v-slot:default="props">
        <v-row>
          <v-col
              v-for="item in props.items"
              :key="item.name"
              cols="12"
              sm="6"
              md="4"
              lg="3"
              class="d-flex"
          >
            <v-card class="d-flex">
              <v-card-title>
                <b>{{ item.discipline }}</b>
              </v-card-title>

              <v-divider></v-divider>

              <v-list dense>
                <v-list-item>
                  <v-list-item-content class="bold"><b>Дата:</b></v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{ item.exam_date }}
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content><b>Время:</b></v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{ item.time }}
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content><b>Преподаватель:</b></v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{ item.person }}
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content><b>Аудитория:</b></v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{ item.classroom }}
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
    <div v-if="student_exams.length">
      <br>
      <v-divider></v-divider>
      <br>
    </div>
    <v-data-iterator v-if="teacher_exams.length"
                     :items="teacher_exams"
                     hide-default-footer
    >
      <template v-slot:header>
        <v-toolbar
            class="mb-2"
            color="indigo darken-5"
            dark
            flat
        >
          <v-toolbar-title>Расписание преподавателя</v-toolbar-title>
        </v-toolbar>
      </template>
      <template v-slot:default="props">
        <v-row>
          <v-col
              v-for="item in props.items"
              :key="item.name"
              cols="12"
              sm="6"
              md="4"
              lg="3"
              class="d-flex"
          >
            <v-card class="d-flex">
              <v-card-title>
                <b>{{ item.discipline }}</b>
              </v-card-title>

              <v-divider></v-divider>

              <v-list dense>
                <v-list-item>
                  <v-list-item-content class="bold"><b>Дата:</b></v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{ item.exam_date }}
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content><b>Время:</b></v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{ item.time }}
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content><b>Группа:</b></v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{ item.group }}
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content><b>Аудитория:</b></v-list-item-content>
                  <v-list-item-content class="align-end">
                    {{ item.classroom }}
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
  </v-container>
</template>
<script>
import axios from "axios";

export default {
  name: 'exam_show',
  data: () => ({
    student_exams: [],
    teacher_exams: [],
  }),

  methods: {
    getInfo() {
      axios({
        method: 'get',
        url: `/exams`,
      }).then((response) => {
        this.student_exams = response.data.exams_student;
        this.teacher_exams = response.data.exams_teacher;
      }).catch((error) => {
        return error;
      });
    },

  },
  mounted() {
    this.getInfo()
  }
}
</script>
